import React from 'react';
import { Button as MuiButton, ButtonProps as MuiButtonProps } from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';
import { Link } from '../link';
import { normalizePath } from '../../lib/paths';

const useButtonStyles = makeStyles({
  root: {
    minWidth: 260,
    '&:hover, &:focus': {
      '& > span > span': {
        animation: '$blinker 1s steps(2, jump-none) infinite',
      },
    },
  },
  blinker: {
    animation: '0',
  },
  '@keyframes blinker': {
    to: { color: 'transparent' },
    from: { color: 'inherit' },
  },
});

interface ButtonProps {
  underscore?: boolean;
  children?: React.ReactNode;
  to?: string;
}

const Button: React.FC<MuiButtonProps & ButtonProps> = ({
  underscore,
  children,
  to,
  ...other
}) => {
  const buttonStyles = useButtonStyles();

  const linkProps = to
    ? {
        component: Link,
        to: normalizePath(to),
      }
    : {};

  return (
    <MuiButton className={buttonStyles.root} {...linkProps} {...other}>
      {children}
      {underscore && (
        <span className={buttonStyles.blinker} aria-hidden="true">
          &nbsp;_
        </span>
      )}
    </MuiButton>
  );
};

Button.defaultProps = {
  underscore: true,
};

export default Button;
